import { render, staticRenderFns } from "./Attribute.vue?vue&type=template&id=7f9e3683&scoped=true&lang=pug&"
import script from "./Attribute.vue?vue&type=script&lang=ts&"
export * from "./Attribute.vue?vue&type=script&lang=ts&"
import style0 from "./Attribute.vue?vue&type=style&index=0&id=7f9e3683&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9e3683",
  null
  
)

export default component.exports